export const GET_TRANSFER_REQUEST = `
query GetTransferRequest($id:ID!){
  transferRequest(id: $id ) {
    id
    contactInformation
    transferStatus
    awaitingFundsDate
    awaitingFundsDaysCount
    requestDate
    transferType
    dueDate
    fromCompanyName
    toCompanyName
    firstContributionDate
    proofOfContributionDocumentUrl
    processingDays
    notifierRecords {
      id
      notificationType
      status
      message
      recipient
      reference
      createdAt
      updatedAt
      customer {
        id  
        petraId
      }
      company {
        id
        petraId
      }
    }
    ticketLinks
    canTransitionToNextStates
    redemptionRequest{
      id
      state
      waiveOffTax
    }
    fromCompany{
      id
      name
    }
    toCompany{
      id
      name
      companySubscriptions {
        id
        product {
          id
          name
          isActive
        }
      }
    }
    transferRequestNotes {
      id
      note {
        id
        description
        user {
          id
          name
        }
        createdAt
        updatedAt
      }
    }
    amount
    customer {
      id
      firstName
      middleName
      lastName
      petraId
      customerSubscriptions {
        id
        product {
          id
          name
          isActive
        }
        computedFirstContributionDate
        firstSchemeContributionDate
        proofOfContributionDocumentUrl
      }
    }
    company {
        id
        name
        petraId
    }
    trusteeScheme {
      id
      name
      trustee {
        id
        name
      }
      trusteeContactPerson {
        id
        firstName
        middleName
        lastName
        email
        phoneNumber
      }
    }
    fromProduct {
        id
        name
    }
    toProduct {
        id
        name
        productTier {
          name
        }
    }
    user {
        id
        name
    }
    transferRequestAttachments {
      id
      attachment {
        id
        url
        name
      }
    }
    transferRequestReason {
      id
      reason {
        id
        reasonDescription
      }
    }
    createdAt
    updatedAt
    idType {
      id
      name
    }
    idNumber
    idUrl
    payoutAccount {
      id
      name
      accountNumber
      accountType
      bankBranch {
        id
        name
        sortCode
        financialInstitution {
          id
          name
        }
      }
    }
    subCategory{
      id
      name
    }
    formerClient
  }
}
`;

export const ASSIGN_ATTACHMENT_TO_TRANSFER_REQUEST = `
  mutation AssignAttachmentsToTransferResquest($attachmentIds: [ID!]!, $transferRequestId: ID!) {
    assignAttachmentsToTransferRequest(attachmentIds: $attachmentIds, transferRequestId: $transferRequestId) {
        transferRequest {
          id
          transferRequestAttachments {
            id
            attachment {
              id
              url
              name
            }
          }
        }
    }
  }
`;

export const ASSIGN_NOTE_TO_TRANSFER_REQUEST = `
  mutation AssignNoteToTransferResquest($noteId: ID!, $transferRequestId: ID!){
    assignNoteToTransferRequest(noteId: $noteId, transferRequestId: $transferRequestId) {
      transferRequestNote {
        note {
          id
          description
          user {
            id
            name
          }
        }
        transferRequest {
          id
        }
      }
    }
  }
`;

export const GET_TRANSFER_REQUEST_REASONS = `
query GetTransferRequestReasons($state:String!){
  transferRequestReasons(state: $state ) {
    id
    reason {
      id
      reasonDescription
      reasonKey
    }
    state
  }
}
`;

export const GET_TRANSFER_REQUEST_LOGS = `
query TransferRequestChangeLogs($transferRequestId: ID!) {
  transferRequestChangeLogs(transferRequestId: $transferRequestId) {
    audits {
      auditItem
      createdAt
      action
      newValue
      oldValue
      user
      comment
    }
    stateAudits {
      auditItem
      createdAt
      action
      newValue
      oldValue
      user
      comment
    }
  }
}
`;

export const UPDATE_CUSTOMER_FIRST_CONTRIBUTION = `
mutation UpdateCustomerSubscription($customerSubscriptionId: ID!, $firstContributionDate: String, $proofOfContributionDocumentUrl: String) {
  updateCustomerSubscription(customerSubscriptionId: $customerSubscriptionId, firstContributionDate: $firstContributionDate, proofOfContributionDocumentUrl: $proofOfContributionDocumentUrl){
    errors {
      property
      description
    }
  }
}
`;

export const UPDATE_TRANSFER_REQUEST = `
mutation UpdateTransferRequest($id:ID!, $transferType: String!, $fromProductId: ID, $toProductId: ID, $companyId: ID, $customerId: ID, $trusteeSchemeId: ID, $userId: ID, $customerInteractionId: ID, $companyInteractionId: ID, $amount: Float, $requestorType: String, $subCategoryId: ID, $currentClientId: ID, $formerClient: String, $requestDate: String, $firstContributionDate: String, $proofOfContributionDocumentUrl: String, $idTypeId: ID, $idNumber: String, $idUrl: String, $fromCompanyName: String, $toCompanyName: String, $accountNumber: String, $accountType: String, $bankBranchId: ID, $name: String, $toCompanyId: ID, $fromCompanyId: ID, $ticketLinks: [String!],  $waiveOffTax: Boolean, $taxWaiverNpraUrl: String) {
  updateTransferRequest(id: $id, transferType: $transferType, fromProductId: $fromProductId, toProductId: $toProductId, companyId: $companyId, customerId: $customerId, trusteeSchemeId: $trusteeSchemeId, userId: $userId, customerInteractionId: $customerInteractionId, companyInteractionId: $companyInteractionId, amount: $amount, requestorType: $requestorType, subCategoryId: $subCategoryId, currentClientId: $currentClientId, formerClient: $formerClient, requestDate:$requestDate, firstContributionDate: $firstContributionDate, proofOfContributionDocumentUrl: $proofOfContributionDocumentUrl, idTypeId: $idTypeId, idNumber: $idNumber, idUrl: $idUrl, fromCompanyName: $fromCompanyName, toCompanyName: $toCompanyName, accountNumber: $accountNumber, accountType: $accountType, bankBranchId: $bankBranchId, name: $name, toCompanyId: $toCompanyId, fromCompanyId: $fromCompanyId, ticketLinks: $ticketLinks,  waiveOffTax: $waiveOffTax, taxWaiverNpraUrl: $taxWaiverNpraUrl){
    transferRequest {
      id
      taxWaiverNpraUrl
      requestDate
      contactInformation
      transferType
      ticketLinks
      company {
        id
        name
      }
      trusteeScheme {
        id
        name
        trustee {
          id
          name
        }
        trusteeContactPerson {
          id
          firstName
          middleName
          lastName
          email
          phoneNumber
        }
      }
      fromProduct {
        id
        name
      }
      toProduct {
        id
        name
      }
      user {
        id
        name
      }
      transferRequestAttachments {
        id
        attachment {
          id
          url
          name
        }
      }
      transferRequestNotes {
        id
        note {
          description
          user {
            id
            name
          }
        }
      }
      idType {
        id
        name
      }
      idNumber
      idUrl
      subCategory{
        id
        name
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_TRANSFER_REQUEST_STATE_ENUM = `
{
  __type(name: "TransferRequestStateEnum") {
    enumValues {
      name
      description
    }
  }
}
`;

export const GET_TRANSFER_REQUEST_SORT_FIELDS = `
{
  __type(name: "TransferRequestSortFieldEnum") {
    enumValues {
      name
      description
    }
  }
}
`;
export const GET_TRANSFER_TYPE_ENUM = `
{
  __type(name: "TransferTypeEnum") {
    enumValues {
      name
      description
    }
  }
}
`;

export const SERACH_TRANSFER_REQUEST = `
query TransferRequestSearch($q: String!, $page: ID!, $numberPerPage: ID, $states: [TransferRequestStateEnum!], $orderBy: TransferRequestOrderByInput, $requestedByIds: [ID!], $transferTypes: [TransferTypeEnum!]){
  transferRequestSearch(q: $q, page: $page, numberPerPage: $numberPerPage, states: $states, orderBy: $orderBy, requestedByIds: $requestedByIds, transferTypes: $transferTypes) {
    count
    results {
      id
      contactInformation
      transferStatus
      requestDate
      transferType
      fromCompanyName
      toCompanyName
      customer {
        id
        firstName
        middleName
        lastName
        petraId
        ssnitNumber
      }
      company {
          id
          name
          petraId
      }
      trusteeScheme {
          id
          name
          trustee {
            id
            name
          }
      }
      fromProduct {
        id
        name
      }
      toProduct {
        id
        name
      }
      user {
          id
          name
      }
      customerInteraction {
        id
      }
      amount
    }
    errors {
      property
      description
    }
  }
}
`;

export const GLOBAL_SEARCH_TRANSFER_REQUEST = `
query GlobalSearchTransferRequest($q: String!, $page: ID!, $numberPerPage: ID){
  transferRequestSearch(q: $q, page: $page, numberPerPage: $numberPerPage) {
    count
    results {
      id
      fromCompanyName
      toCompanyName
      customer {
        id
        firstName
        middleName
        lastName
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const CREATE_TRANSFER_REQUEST = `
  mutation CreateTransferRequest($requestDate: String!, $transferType: String!, $requestorType: String!, $fromProductId: ID, $toProductId: ID, $fromCompanyId: ID, $toCompanyId: ID, $companyId: ID, $customerId: ID, $trusteeSchemeId: ID, $userId: ID, $customerInteractionId: ID, $companyInteractionId: ID, $contactInformation: String!, $idTypeId: ID, $idNumber: String, $idUrl: String, $bankBranchId: ID, $name: String, $accountNumber: String, $accountType: String, $amount: Float, $subCategoryId: ID!, $firstContributionDate: String, $proofOfContributionDocumentUrl: String, $fromCompanyName: String, $toCompanyName: String, $ticketLinks: [String!], $waiveOffTax: Boolean, $taxWaiverNpraUrl: String) {
    createTransferRequest(requestDate: $requestDate, transferType: $transferType, requestorType: $requestorType, fromProductId: $fromProductId, fromCompanyId: $fromCompanyId, toCompanyId: $toCompanyId, toProductId: $toProductId, companyId: $companyId, customerId: $customerId, trusteeSchemeId: $trusteeSchemeId, userId: $userId, customerInteractionId: $customerInteractionId, companyInteractionId: $companyInteractionId, contactInformation: $contactInformation, idTypeId: $idTypeId, idNumber: $idNumber, idUrl: $idUrl, bankBranchId: $bankBranchId, name: $name, accountNumber:$accountNumber, accountType: $accountType, amount: $amount, subCategoryId: $subCategoryId, firstContributionDate: $firstContributionDate, proofOfContributionDocumentUrl: $proofOfContributionDocumentUrl, fromCompanyName: $fromCompanyName, toCompanyName: $toCompanyName, ticketLinks: $ticketLinks, waiveOffTax: $waiveOffTax, taxWaiverNpraUrl: $taxWaiverNpraUrl){
      transferRequest {
        id
        taxWaiverNpraUrl
        requestDate
        contactInformation
        transferType
        requestorType
        fromCompanyName
        toCompanyName
        payoutAccount{
          id
          name
          accountNumber
          accountType
          bankBranch {
            id
            name
            financialInstitution {
              id
              name
            }
          }
        }
        company {
          id
          name
        }
        trusteeScheme {
          id
          name
          trustee {
            id
            name
          }
          trusteeContactPerson {
            id
            firstName
            middleName
            lastName
            email
            phoneNumber
          }
        }
        fromProduct {
          id
          name
        }
        toProduct {
          id
          name
        }
        user {
          id
          name
        }
        transferRequestAttachments {
          id
          attachment {
            id
            url
            name
          }
        }
        transferRequestNotes {
          id
          note {
            description
            user {
              id
              name
            }
          }
        }
        idType {
          id
          name
        }
        idNumber
        idUrl
      }
      errors {
        property
        description
      }
    }
  }
`;

export const MOVE_TRANSFER_REQUEST_TO_STATE = `
 mutation MoveTransferRequestToState($transferRequestId: ID!, $transferRequestReasonId: ID, $comment: String, $state: String!, $firstContributionDate: String, $proofOfContributionDocumentUrl: String){
   moveTransferRequestToState(transferRequestId: $transferRequestId, transferRequestReasonId: $transferRequestReasonId, comment: $comment, state: $state,  firstContributionDate: $firstContributionDate, proofOfContributionDocumentUrl: $proofOfContributionDocumentUrl) {
      transferRequest {
        id
      }
      errors{
        description
        property
      }
    }
  }
`;

export const FOLLOW_UP_TRANSFER_REQUEST = `
  mutation FollowUpTransferRequest($transferRequestId: ID!, $templateId: ID!) {
    followUpTransferRequest(transferRequestId: $transferRequestId, templateId: $templateId) {
      transferRequest {
        id
        transferStatus
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_TRANSFER_REQUEST_NOTIFIER_RECORDS_QUERY = `
query GetTransferRequest($transferRequestId: ID!) {
  transferRequest(id: $transferRequestId) {
    notifierRecords {
      id
      notificationType
      status
      message
      recipient
      reference
      createdAt
      updatedAt
      customer {
        id  
        petraId
      }
      company {
        id
        petraId
      }
    }
  }
}
`;